<script lang="ts" setup>
  import { cn } from "@/lib/utils"
  import {
    StepperSeparator,
    useForwardProps,
    type StepperSeparatorProps,
  } from "reka-ui"
  import { computed, type HTMLAttributes } from "vue"

  type IndicatorPosition = "start" | "last" | ""

  const props = defineProps<
    StepperSeparatorProps & {
      class?: HTMLAttributes["class"]
      position: IndicatorPosition
      isCompleted?: boolean
    }
  >()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })

  const forwarded = useForwardProps(delegatedProps)
</script>

<template>
  <StepperSeparator
    v-bind="forwarded"
    :class="
      cn(
        'absolute z-0 rounded-full bg-secondary-300',
        isCompleted && 'bg-primary-400',
        'left-3 top-7 h-full w-2',
        'sm:left-[calc(50%+10px)] sm:top-3 sm:block sm:h-2 sm:w-[96%]',
        position === 'start' && 'top-8 sm:left-[calc(50%+18px)]',
        position === 'last' && 'top-4 sm:left-[calc(50%+5px)]',
        props.class,
      )
    "
  />
</template>
